(function () {
  'use strict';
  if (window.CsgSale) { window.CsgSale.initAll(); return; }
  const instances = new Map();
  const refreshInterval = 3 * 60 * 1000;
  const cardBatchSize = 12;
  const percentFormat = new Intl.NumberFormat(document.documentElement.lang || 'de', { maximumFractionDigits: 1 });
  const plan = { schedule: ["e_fully", "e_trekking", "e_hardtail", "gravel", "road", "hardtail", "kids", "youth", "fully", "trekking", "e_gravel", "e_city", "cargo"] };
  const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  function slotInfo(time) {
    const p = Object.fromEntries(fmt.formatToParts(new Date(time)).map(part => [part.type, part.value]));
    const date = p.year + '-' + p.month + '-' + p.day;
    const slot = Number(p.hour) * 2 + Math.floor(Number(p.minute) / 30);
    return { date, slot, key: date + ':' + slot, day: Math.floor(Date.parse(date + 'T00:00:00Z') / 86400000) };
  }
  function nextBoundary(time) {
    return (Math.floor(time / 1800000) + 1) * 1800000;
  }

  const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  function compactSize(label) {
    return String(label || '').replace(/easy[ -]?entry|trapeze?/gi, '').replace(/\s+/g, ' ').trim();
  }
  function sizeGroup(product, variant) {
    const label = compactSize(variant.size).toUpperCase();
    if (/ONE\s*SIZE|EINHEITS|UNISIZE/.test(label)) return '';
    if (product.family === 'kids') {
      const wheel = label.match(/^(12|14|16|18|20|24|26|27[.,]5|29)\s*(?:["″]|ZOLL|INCH)$/);
      return wheel ? wheel[1].replace(',', '.') : '';
    }
    if (label === 'XXS') return 'XS';
    if (sizeOrder.includes(label)) return label;
    const cm = label.match(/^(\d{2})(?:[.,]0)?\s*(?:CM)?$/);
    if (!cm) return '';
    const title = product.title.toLowerCase();
    const road = {47:'XS',50:'XS',52:'S',53:'S',54:'M',56:'M',58:'L',60:'XL',62:'XXL'};
    const trekking = {46:'XS',50:'S',54:'M',58:'L',62:'XL',64:'XXL'};
    const city = {42:'XS',46:'S',50:'M',54:'L',58:'XL'};
    const aruba = {45:'S',49:'M',53:'L'};
    const mapping = /agree|attain|litening/.test(title) ? road : /supreme|aruba.*hybrid/.test(title) ? city : /aruba/.test(title) ? aruba : /kathmandu|touring|nuride|nature|editor/.test(title) ? trekking : {};
    return mapping[Number(cm[1])] || '';
  }
  function eligibleVariants(product, size = '') {
    return (product.variants || []).filter(v => {
      if (!['current', 'former', 'model_year'].includes(v.referenceKind) || !Number.isSafeInteger(v.referenceCents) || v.referenceCents <= 0) return false;
      if (v.referenceKind === 'model_year' && (!Number.isInteger(product.modelYear) || product.modelYear < 2000 || product.modelYear > 2026)) return false;
      return v.inStock === true && Number.isSafeInteger(v.priceCents) && v.priceCents > 0 && v.compareCents === v.referenceCents && v.compareCents > v.priceCents && (!size || sizeGroup(product, v) === size);
    });
  }
  function forSize(product, size = '') {
    const candidates = eligibleVariants(product, size).slice().sort((a,b) => a.priceCents - b.priceCents || a.id.localeCompare(b.id));
    const v = candidates[0];
    if (!v) return null;
    const stockSizes = [...new Set(candidates.filter(c => c.inStock).map(c => {
      const sameConfiguration = (c.options || []).every((value, i) => i === product.sizeIndex || value === (v.options || [])[i]);
      return sameConfiguration ? compactSize(c.size) : c.variant;
    }).filter(Boolean))].join(' · ');
    const variantUrl = new URL(v.url || product.url, location.origin);
    variantUrl.searchParams.set('variant', v.id);
    return { ...product, ...v, id: product.id, variantId: v.id, stockSizes, selectedSize: size,
      url: variantUrl.pathname + variantUrl.search + variantUrl.hash, image: v.image || product.image };
  }
  function selectSlot(items, key, count, preferredFamily = '', size = '') {
    const [date, slotText] = key.split(':');
    const slot = Number(slotText), day = Math.floor(Date.parse(date + 'T00:00:00Z') / 86400000);
    if (!Number.isFinite(day) || !Number.isInteger(slot) || slot < 0 || slot > 47) return { items: [], family: '' };
    const unique = new Map(items.filter(p => p.id && p.title && p.url && p.image && Number.isInteger(p.modelYear) && p.modelYear >= 2000 && p.modelYear <= 2026 && !/\b20(?:2[7-9]|[3-9]\d)\b/.test(p.title) && p.available === true && plan.schedule.includes(p.family)).map(p => [String(p.id), p]));
    const categoryIndex = slot % plan.schedule.length;
    const order = plan.schedule.slice(categoryIndex).concat(plan.schedule.slice(0, categoryIndex));
    const family = plan.schedule.includes(preferredFamily) ? preferredFamily : order.find(f => [...unique.values()].some(p => p.family === f && eligibleVariants(p, size).length));
    if (!family) return { items: [], family: '' };
    const group = [...unique.values()].filter(p => p.family === family).map(p => forSize(p, size)).filter(Boolean).sort((a,b) => (1 - b.priceCents / b.compareCents) - (1 - a.priceCents / a.compareCents) || (b.compareCents - b.priceCents) - (a.compareCents - a.priceCents) || String(a.id).localeCompare(String(b.id)));
    const capacity = Math.max(1, Math.min(120, Math.floor(Number(count) || 120)));
    function rotate(pool, slots) {
      const target = Math.min(pool.length, slots);
      if (!target) return [];
      const stride = Math.max(1, Math.min(target, pool.length - 1));
      const offset = ((day * stride + slot) % pool.length + pool.length) % pool.length;
      return Array.from({ length: target }, (_, i) => pool[(offset + i) % pool.length]);
    }
    const stocked = rotate(group.filter(p => p.inStock), capacity);
    return { family, items: stocked, total: group.length };
  }
  function create(tag, cls, text) {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }
  function discountPercent(price, compare) {
    if (!(Number.isFinite(price) && Number.isFinite(compare) && price > 0 && compare > price)) return 0;
    return Math.floor((compare - price) * 1000 / compare) / 10;
  }
  function discountText(p, strings) {
    const percent = discountPercent(p.priceCents, p.compareCents);
    return percent ? percentFormat.format(percent) + ' %' : strings.small_discount;
  }
  function card(p, strings) {
    const li = create('li', 'csgsale-card');
    li.dataset.productId = p.id; li.dataset.family = p.family; li.dataset.variantId = p.variantId; li.dataset.modelYear = p.modelYear; li.dataset.priceCents = p.priceCents; li.dataset.compareCents = p.compareCents; li.dataset.referenceKind = p.referenceKind;
    const a = create('a', 'csgsale-card-link'); a.href = p.url;
    const visual = create('div', 'csgsale-image');
    const former = p.referenceKind === 'former';
    const modelYear = p.referenceKind === 'model_year';
    const shortYear = String(p.modelYear).slice(-2);
    const basisLabel = modelYear ? strings.model_year_compare_label.replace('%year%', p.modelYear) : former ? strings.former_compare_label : strings.compare_label;
    const belowLabel = modelYear ? strings.below_model_year_reference.replace('%short_year%', shortYear) : former ? strings.below_former_reference : strings.below_reference;
    const percentText = discountText(p, strings);
    const badge = create('span', 'csgsale-badge');
    badge.append(create('span', 'csgsale-badge-value', percentText), document.createTextNode(' '), create('span', 'csgsale-badge-label', belowLabel));
    badge.setAttribute('aria-label', percentText + ' ' + belowLabel);
    visual.append(badge, create('span', 'csgsale-year', 'MY' + String(p.modelYear).slice(-2)));
    const img = create('img');
    const imageUrl = new URL(p.image, location.origin);
    img.srcset = [320, 480, 640].map(width => {
      const source = new URL(imageUrl); source.searchParams.set('width', width);
      return source.href + ' ' + width + 'w';
    }).join(', ');
    img.sizes = '(max-width: 540px) 85vw, (max-width: 800px) 45vw, 320px';
    img.src = p.image; img.alt = p.title;
    img.width = 640; img.height = 480; img.loading = 'lazy'; img.decoding = 'async';
    visual.append(img);
    const body = create('div', 'csgsale-body');
    body.append(create('span', 'csgsale-type', strings.families[p.family]));
    body.append(create('h3', 'csgsale-title', p.title.replace(/^cube\s+/i, '').replace(/\s+20\d{2}$/i, '')));
    body.append(create('p', 'csgsale-variant', p.variant && p.variant !== 'Default Title' ? (strings.price_for || '%variant%').replace('%variant%', p.variant) : strings.variant));
    if (p.inStock === true) body.append(create('span', 'csgsale-stock', strings.in_stock + (p.stockSizes ? ': ' + p.stockSizes : '')));
    const price = create('div', 'csgsale-price');
    const compareLine = create('span', 'csgsale-reference');
    compareLine.append(create('span', 'csgsale-reference-label', basisLabel + ': '), create('s', 'csgsale-compare', p.comparePrice));
    const currentLabel = create('span', 'csgsale-current-label', strings.sale_price + ':');
    const current = create('strong', '', p.price); current.setAttribute('aria-label', strings.sale_price + ': ' + p.price);
    const saving = create('span', 'csgsale-saving', (modelYear ? strings.model_year_save : former ? strings.former_save : strings.save).replace('%saving%', p.saving).replace('%short_year%', shortYear));
    price.append(compareLine, currentLabel, current, saving);
    body.append(price);
    const link = create('span', 'csgsale-card-cta', strings.discover);
    const arr = create('span', '', '→'); arr.setAttribute('aria-hidden', 'true'); link.append(arr);
    body.append(link); a.append(visual, body); li.append(a); return li;
  }
  class Carousel {
    constructor(root) {
      this.root = root; this.track = root.querySelector('[data-csgsale-track]');
      this.prev = root.querySelector('[data-csgsale-prev]'); this.next = root.querySelector('[data-csgsale-next]');
      this.position = root.querySelector('[data-csgsale-position]'); this.live = root.querySelector('[data-csgsale-live]');
      this.strings = JSON.parse(root.querySelector('[data-csgsale-strings]').textContent);
      this.key = ''; this.lastFetch = 0; this.items = []; this.limit = Math.max(4, Math.min(120, Number(root.dataset.limit) || 24));
      this.selected = null;
      this.loadedFamily = ''; this.requestId = 0; this.pendingData = null;
      this.root.dataset.family = root.dataset.renderedFamily || '';
      this.serverFamily = root.dataset.renderedFamily || '';
      this.serverSlot = Number(root.dataset.renderedSlot) || Math.floor(Date.now() / 1800000);
      this.serverIds = [...this.track.children].map(node => String(node.dataset.productId || '')).filter(Boolean);

      this.initialFamily = plan.schedule.includes(root.dataset.initialFamily) ? root.dataset.initialFamily : '';
      this.rotate = root.dataset.rotate !== 'false';
      this.picker = root.querySelector('[data-csgsale-picker]');
      this.pickerSelect = root.querySelector('[data-csgsale-select]');
      this.manualFamily = this.initialFamily;
      this.sizes = { adult: '', kids: '' };
      this.sizeSelect = root.querySelector('[data-csgsale-size]');
      this.empty = root.querySelector('[data-csgsale-empty]');
      this.emptyDefault = this.empty.innerHTML;
      this.reset = root.querySelector('[data-csgsale-reset]');
      this.preferenceKey = 'csgsale-family:' + root.dataset.feed;
      try {
        const saved = sessionStorage.getItem(this.preferenceKey);
        if (saved === '' || plan.schedule.includes(saved)) this.manualFamily = saved;
        const sizes = JSON.parse(sessionStorage.getItem(this.preferenceKey + ':sizes') || '{}');
        if (sizeOrder.includes(sizes.adult)) this.sizes.adult = sizes.adult;
        if (/^(12|14|16|18|20|24|26|27\.5|29)$/.test(sizes.kids)) this.sizes.kids = sizes.kids;
      } catch {}
      this.loading = false; this.destroyed = false;
      this.visible = false; this.deferredRender = false; this.started = false;
      this.events = new AbortController(); const opt = { signal: this.events.signal };
      this.prev.addEventListener('click', () => this.scroll(-1), opt);
      this.next.addEventListener('click', () => this.scroll(1), opt);
      if (this.picker) this.picker.addEventListener('click', e => {
        const button = e.target.closest('[data-csgsale-family]');
        if (button && this.picker.contains(button)) this.chooseFamily(button.dataset.csgsaleFamily);
      }, opt);
      if (this.pickerSelect) {
        this.pickerSelect.disabled = false;
        this.pickerSelect.value = this.manualFamily;
        this.pickerSelect.addEventListener('change', e => this.chooseFamily(e.target.value), opt);
      }
      this.sizeSelect.addEventListener('change', e => this.chooseSize(e.target.value), opt);
      this.reset.addEventListener('click', () => this.chooseSize(''), opt);
      this.track.addEventListener('scroll', () => { if (this.track.scrollLeft > 2) this.initialScrollIntent = true; this.requestControls(); }, { passive: true, signal: this.events.signal });
      this.track.addEventListener('pointerdown', () => { clearTimeout(this.pointerReleaseTimer); this.pointerActive = true; }, { passive: true, signal: this.events.signal });
      const releasePointer = () => {
        if (!this.pointerActive) return;
        this.pointerReleaseTimer = setTimeout(() => { this.pointerActive = false; this.enhanceAfterScroll(); this.flushDeferred(); }, 0);
      };
      window.addEventListener('pointerup', releasePointer, opt);
      window.addEventListener('pointercancel', releasePointer, opt);
      // Native touch panning cancels Pointer Events before the finger lifts.
      // Keep that contact protected until its own touchend/touchcancel event.
      this.track.addEventListener('touchstart', () => { clearTimeout(this.touchReleaseTimer); this.touchActive = true; }, { passive: true, signal: this.events.signal });
      const releaseTouch = event => {
        if (!this.touchActive || event.touches?.length) return;
        this.touchReleaseTimer = setTimeout(() => { this.touchActive = false; this.enhanceAfterScroll(); this.flushDeferred(); }, 0);
      };
      window.addEventListener('touchend', releaseTouch, { passive: true, signal: this.events.signal });
      window.addEventListener('touchcancel', releaseTouch, { passive: true, signal: this.events.signal });
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.scroll(e.key === 'ArrowRight' ? 1 : -1); }
      }, opt);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.checkSlot(); }, opt);
      window.addEventListener('pageshow', () => this.checkSlot(), opt);
      this.resize = new ResizeObserver(() => this.requestControls()); this.resize.observe(this.track);
      this.visibility = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.flushDeferred();
        this.checkSlot();
      });
      this.visibility.observe(this.root);
      this.root.addEventListener('focusout', () => queueMicrotask(() => { this.flushDeferred(); this.checkSlot(); }), opt);
      this.preload = new IntersectionObserver(entries => {
        this.nearViewport = entries.some(entry => entry.isIntersecting);
        if (this.nearViewport) { this.start(); this.checkSlot(); } else this.schedule();
      }, { rootMargin: '200px 0px' });
      this.preload.observe(this.root);
      this.root.addEventListener('pointerdown', () => this.start(true), opt);
      this.root.addEventListener('focusin', () => this.start(true), opt);
      this.controls();
    }
    start(interactive = false) {
      if (this.destroyed || document.hidden) return;
      if (this.started) {
        if (interactive) {
          if (this.startScheduled && window.cancelIdleCallback) window.cancelIdleCallback(this.idle);
          this.startScheduled = false;
          // Clicking a product or entering its link with the keyboard must not
          // replace it underneath the pointer/focus. Filters commit explicitly.
          if (!this.pendingData && !this.loading && !this.loadedFamily) this.load();
        }
        return;
      }
      if (!interactive && !this.nearViewport && !this.visible) return;
      // Keep product traffic out of the hero image's critical loading phase.
      if (!interactive && document.readyState !== 'complete') {
        if (!this.waitingForLoad) {
          this.waitingForLoad = true;
          window.addEventListener('load', () => this.start(), { once: true, signal: this.events.signal });
        }
        return;
      }
      this.started = true;
      const begin = () => {
        this.startScheduled = false;
        if (!this.destroyed && !this.loading && !this.loadedFamily && !this.pendingData) this.load();
      };
      if (!interactive && 'requestIdleCallback' in window) {
        this.startScheduled = true;
        this.idle = window.requestIdleCallback(begin, { timeout: 1000 });
      } else begin();
    }
    requestControls() {
      if (this.controlFrame) return;
      this.controlFrame = requestAnimationFrame(() => { this.controlFrame = 0; if (!this.destroyed) { this.enhanceAfterScroll(); this.controls(); } });
    }
    appendCards() {
      if (!this.selected || this.track.children.length >= this.selected.length) return;
      const start = this.track.children.length;
      const fragment = document.createDocumentFragment();
      this.selected.slice(start, start + cardBatchSize).forEach(p => fragment.append(card(p, this.strings)));
      this.track.append(fragment);
    }
    currentSize() {
      const family = this.loadedFamily || this.root.dataset.family;
      if (!this.items.some(p => p.family === family && eligibleVariants(p).some(v => sizeGroup(p, v)))) return '';
      return this.sizes[family === 'kids' ? 'kids' : 'adult'];
    }
    savePreferences() {
      try {
        sessionStorage.setItem(this.preferenceKey, this.manualFamily);
        sessionStorage.setItem(this.preferenceKey + ':sizes', JSON.stringify(this.sizes));
      } catch {}
    }
    chooseFamily(family) {
      if (family !== '' && !plan.schedule.includes(family)) return;
      if (family === this.manualFamily && this.loadedFamily === family && !this.pendingData && !this.loading) return;
      this.manualFamily = family;
      if (!family) this.sizes = { adult: '', kids: '' };
      this.savePreferences();
      this.deferredRender = false; this.pendingData = null;
      this.started = true;
      if (this.startScheduled && window.cancelIdleCallback) window.cancelIdleCallback(this.idle);
      this.startScheduled = false;
      this.load(true);
    }
    chooseSize(size) {
      if (this.pendingData && (!this.loadedFamily || this.pendingData.family === this.loadedFamily)) this.commit(this.pendingData, true);
      if (!this.key || !this.loadedFamily || (this.manualFamily && this.manualFamily !== this.loadedFamily)) return;
      // Sizes only filter the already loaded family, without another request.
      if (!this.manualFamily) this.manualFamily = this.loadedFamily;
      const mode = this.manualFamily === 'kids' ? 'kids' : 'adult';
      this.sizes[mode] = size;
      this.savePreferences();
      this.requestId++; this.loading = false; this.pendingData = null;
      this.root.removeAttribute('aria-busy');
      this.deferredRender = false;
      this.render(true, true); this.schedule();
    }
    syncPicker(items = this.items, family = this.loadedFamily || this.root.dataset.family) {
      if (!this.picker) return;
      this.picker.hidden = false;
      this.pickerSelect.disabled = false;
      this.root.dataset.selectionMode = this.manualFamily ? 'manual' : 'auto';
      for (const option of this.pickerSelect.options) option.disabled = false;
      this.pickerSelect.value = this.manualFamily;
      const kids = family === 'kids';
      const current = items.some(p => p.family === family && eligibleVariants(p).some(v => sizeGroup(p, v))) ? this.sizes[kids ? 'kids' : 'adult'] : '';
      const counts = new Map();
      for (const product of items.filter(p => p.family === family)) {
        for (const group of new Set(eligibleVariants(product).map(v => sizeGroup(product, v)).filter(Boolean))) counts.set(group, (counts.get(group) || 0) + 1);
      }
      const values = kids ? [...new Set([...counts.keys(), ...(current ? [current] : [])])].sort((a,b) => Number(a)-Number(b)) : sizeOrder;
      const fragment = document.createDocumentFragment();
      const all = create('option', '', this.strings.all_sizes); all.value = ''; fragment.append(all);
      for (const value of values) {
        const label = kids ? value.replace('.', ',') + '″' : value;
        const option = create('option', '', label + ' (' + (counts.get(value) || 0) + ')'); option.value = value; option.disabled = !counts.get(value); fragment.append(option);
      }
      this.sizeSelect.replaceChildren(fragment); this.sizeSelect.value = current;
      this.sizeSelect.disabled = counts.size === 0 && !current;
      this.root.querySelector('[data-csgsale-size-label]').textContent = kids ? this.strings.wheel_label : this.strings.size_label;
      const hint = this.root.querySelector('[data-csgsale-size-hint]');
      hint.textContent = counts.size ? this.strings.size_hint : this.strings.no_options;
      hint.hidden = kids;
      this.reset.hidden = !current;
    }
    scroll(dir) {
      if (this.pendingData && !this.signature) this.commit(this.pendingData, true);
      const first = this.track.firstElementChild; if (!first) return;
      const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 18);
      const per = Math.max(1, Math.floor((this.track.clientWidth + 18) / step));
      this.track.scrollBy({ left: dir * step * per, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    controls() {
      // Add the next few screens only when the customer approaches the end.
      if (this.selected && this.track.scrollLeft + this.track.clientWidth * 2 >= this.track.scrollWidth) this.appendCards();
      const n = this.selected ? this.selected.length : this.pendingData ? this.pendingCount : this.track.children.length;
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = !n || this.track.scrollLeft < 3;
      this.next.disabled = !n || (this.track.children.length >= n && (max < 3 || this.track.scrollLeft >= max - 3));
      if (this.pendingData && !this.signature && this.pendingCount > this.track.children.length) this.next.disabled = false;
      if (!n) { this.position.textContent = ''; return; }
      const first = this.track.firstElementChild;
      const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 18);
      const start = Math.min(n, Math.round(this.track.scrollLeft / step) + 1);
      const visible = Math.max(1, Math.floor((this.track.clientWidth + 18) / step));
      this.position.textContent = start + '–' + Math.min(n, start + visible - 1) + ' / ' + n;
    }
    activeView() {
      return this.visible || this.root.contains(document.activeElement) || this.pointerActive || this.touchActive;
    }
    restoringPreference(result) {
      return !this.signature && this.manualFamily && result.family === this.manualFamily &&
        (result.family !== this.root.dataset.family || this.sizes[result.family === 'kids' ? 'kids' : 'adult']);
    }
    productInteraction() {
      return this.pointerActive || this.touchActive || (this.track.contains(document.activeElement) && document.activeElement !== this.track);
    }
    enhanceAfterScroll() {
      if (this.destroyed || this.signature || !this.initialScrollIntent || !this.pendingData || this.productInteraction()) return;
      if (this.pendingData.family !== this.root.dataset.family || this.track.scrollWidth - this.track.clientWidth - this.track.scrollLeft > this.track.clientWidth) return;
      const position = this.track.scrollLeft;
      this.initialScrollIntent = false;
      this.commit(this.pendingData, true);
      this.track.scrollLeft = position;
      this.controls();
    }
    flushDeferred() {
      if (this.destroyed) return;
      if (this.pendingData && this.restoringPreference(this.pendingData) && !this.productInteraction()) this.commit(this.pendingData, true);
      if (this.activeView()) return;
      if (this.pendingData) this.commit(this.pendingData, false);
      else if (this.deferredRender) { this.deferredRender = false; this.render(true, true); }
    }
    commit(result, force) {
      if (this.destroyed || result.token !== this.requestId) return;
      // Visible server cards remain stable while controls receive fresh data.
      // The first explicit filter/Next interaction can accept the enhancement.
      const restore = this.restoringPreference(result) && !this.productInteraction();
      if (!force && !restore && this.activeView() && (this.signature || this.track.children.length)) {
        this.pendingData = result;
        if (!this.signature) {
          this.pendingCount = selectSlot(result.items, result.key, this.limit, result.family).items.length;
          if (result.family === this.root.dataset.family) this.syncPicker(result.items, result.family);
          this.controls();
          this.enhanceAfterScroll();
        }
        return;
      }
      this.pendingData = null; this.deferredRender = false;
      this.items = result.items; this.loadedFamily = result.family; this.key = result.key; this.lastFetch = result.fetchedAt;
      this.render(result.announce, true);
      this.root.dataset.catalogueStatus = 'ready';
    }
    render(announce, force = false) {
      if (!force && this.signature && (this.visible || this.root.contains(document.activeElement))) {
        this.deferredRender = true;
        return;
      }
      const family = this.loadedFamily || this.manualFamily || this.root.dataset.family;
      const selection = selectSlot(this.items, this.key, this.limit, family, this.manualFamily ? this.currentSize() : '');
      let selected = selection.items;
      if (!this.signature && selection.family === this.serverFamily && !this.currentSize() && this.key === slotInfo(this.serverSlot * 1800000).key) {
        // Preserve the four already seen bikes at the front, then append each
        // remaining product once. Revalidate every server ID against live data.
        const eligible = new Map(selectSlot(this.items, this.key, 120, selection.family).items.map(p => [String(p.id), p]));
        const prefix = [...new Set(this.serverIds)].map(id => eligible.get(id)).filter(Boolean).slice(0, this.limit);
        const seen = new Set(prefix.map(p => String(p.id)));
        selected = [...prefix, ...selected.filter(p => !seen.has(String(p.id)))].slice(0, this.limit);
      }
      this.root.dataset.family = selection.family;
      this.track.dataset.count = selected.length;
      this.syncPicker();
      const familyLabel = this.strings.families[selection.family];
      if (familyLabel) this.root.querySelector('[data-csgsale-title]').textContent = this.strings.heading.replace('%family%', familyLabel);
      const chosenSize = this.currentSize();
      this.root.querySelector('[data-csgsale-note]').textContent = (chosenSize ? this.strings.filtered_note : (this.manualFamily || !this.rotate) ? this.strings.manual_note : this.strings.note).replace('%count%', selected.length).replace('%size%', selection.family === 'kids' ? chosenSize + '″' : chosenSize);
      this.root.dataset.selectionSlot = this.key;
      if (announce && familyLabel) this.live.textContent = this.strings.updated.replace('%family%', familyLabel).replace('%count%', selected.length);
      const signature = JSON.stringify([this.manualFamily, this.currentSize(), selection.family, selected]);
      if (signature === this.signature) return;
      this.signature = signature;
      this.selected = selected;
      if (!selected.length) {
        this.track.replaceChildren();
        if (this.currentSize()) this.empty.textContent = this.strings.filtered_empty; else this.empty.innerHTML = this.emptyDefault;
        this.empty.hidden = false;
        this.controls(); return;
      }
      const previousFocus = this.root.contains(document.activeElement) && this.track.contains(document.activeElement);
      this.root.querySelector('[data-csgsale-empty]').hidden = true;
      this.track.replaceChildren(); this.track.scrollLeft = 0;
      this.appendCards();
      this.controls();
      if (previousFocus) this.track.focus({ preventScroll: true });
    }
    feedUrl() {
      const url = new URL(this.root.dataset.feed, location.origin);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      url.searchParams.set('section_id', 'csg-sale-feed');
      url.searchParams.set('sort_by', 'title-ascending');
      return url.href;
    }
    async load(force = false, refresh = false) {
      if (this.destroyed) return;
      const nextKey = !this.rotate && this.key ? this.key : slotInfo(Date.now()).key;
      const slot = Number(nextKey.split(':')[1]) % plan.schedule.length;
      const requestedMode = this.manualFamily;
      const requestKey = JSON.stringify([requestedMode, nextKey, refresh]);
      if (this.loading && this.requestKey === requestKey) {
        if (force) this.forceRequest = true;
        return this.loadingPromise;
      }
      const token = ++this.requestId;
      this.requestKey = requestKey; this.forceRequest = force; this.loading = true;
      this.pendingData = null; this.lastAttempt = Date.now();
      this.root.setAttribute('aria-busy', 'true'); this.root.dataset.catalogueStatus = 'loading';
      this.sizeSelect.disabled = true;
      if (this.pickerSelect) { this.pickerSelect.disabled = false; this.pickerSelect.value = this.manualFamily; }
      this.loadingPromise = (async () => {
        try {
          const cache = window.CsgCatalogueCache;
          if (!cache) throw new Error('Catalogue cache unavailable');
          // The compact Sale catalogue is small. Fetch its four source pages
          // once, rather than traversing them again for each empty category.
          const data = await cache.get(this.feedUrl(), {
            selector: '[data-csgsale-feed]', family: 'all', mode: 'sale',
            locale: document.documentElement.lang || 'de', currency: this.root.dataset.currency || ''
          });
          if (this.destroyed || token !== this.requestId) return;
          if (data.family !== 'all' || !Array.isArray(data.items)) throw new Error('Invalid Sale catalogue');
          let preferred = requestedMode || (refresh ? this.loadedFamily : '');
          if (!preferred && !this.signature && this.serverIds.length && nextKey === slotInfo(this.serverSlot * 1800000).key && selectSlot(data.items, nextKey, this.limit, this.serverFamily).items.length) preferred = this.serverFamily;
          const chosen = selectSlot(data.items, nextKey, this.limit, preferred);
          const family = requestedMode || chosen.family || plan.schedule[slot];
          const result = { ...data, family, key: nextKey, token, announce: Boolean(this.key || this.forceRequest) };
          this.commit(result, this.forceRequest);
          if (this.pendingData) this.root.dataset.catalogueStatus = 'pending';
        } catch (error) {
          if (this.destroyed || token !== this.requestId) return;
          this.root.dataset.catalogueStatus = 'fallback';
          this.root.querySelector('[data-csgsale-note]').textContent = this.strings.fallback;
          if (!this.track.children.length) this.empty.hidden = false;
          console.warn('[CUBE price comparison] Category feed temporarily unavailable; retaining rendered products.', error);
        } finally {
          if (token === this.requestId) {
            this.loading = false; this.root.removeAttribute('aria-busy');
            if (!this.destroyed) this.schedule();
          }
        }
      })();
      return this.loadingPromise;
    }
    checkSlot() {
      if (this.destroyed || document.hidden) { this.schedule(); return; }
      if (!this.started) { if (this.nearViewport || this.visible) this.start(); return; }
      this.flushDeferred();
      if (this.startScheduled || this.loading || this.pendingData || (!this.nearViewport && !this.visible)) { this.schedule(); return; }
      const now = Date.now();
      const changedSlot = this.rotate && this.key && slotInfo(now).key !== this.key;
      if (changedSlot) {
        if (!this.activeView() && now - (this.lastAttempt || 0) >= 60000) this.load();
      } else if (now - this.lastFetch >= refreshInterval && now - (this.lastAttempt || 0) >= 60000) this.load(false, true);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.destroyed || !this.started || document.hidden || (!this.nearViewport && !this.visible)) return;
      const now = Date.now();
      const untilRefresh = Math.max(60000, refreshInterval - (now - this.lastFetch));
      this.timer = setTimeout(() => this.checkSlot(), Math.max(100, Math.min(nextBoundary(now) - now + 100, untilRefresh)));
    }
    destroy() {
      this.destroyed = true; this.requestId++; this.pendingData = null; this.root.removeAttribute('aria-busy'); clearTimeout(this.timer); this.events.abort();
      clearTimeout(this.pointerReleaseTimer);
      clearTimeout(this.touchReleaseTimer);
      if (this.controlFrame) cancelAnimationFrame(this.controlFrame);
      if (this.idle && window.cancelIdleCallback) window.cancelIdleCallback(this.idle);
      this.resize.disconnect(); this.visibility.disconnect(); this.preload.disconnect();
    }
  }
  function initAll() {
    instances.forEach((value, key) => { if (!value.root.isConnected) { value.destroy(); instances.delete(key); } });
    document.querySelectorAll('[data-csgsale-carousel]').forEach(root => {
      if (instances.has(root.id)) { if (instances.get(root.id).root === root) return; instances.get(root.id).destroy(); }
      instances.set(root.id, new Carousel(root));
    });
  }
  window.CsgSale = { initAll, slotInfo, nextBoundary, selectSlot, sizeGroup, forSize, discountPercent };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', e => {
    instances.forEach((value,key) => { if (e.target.contains(value.root)) { value.destroy(); instances.delete(key); } });
  });
})();
